import {
	IsEmailTakenMutation,
	IsEmailTakenMutationVariables,
} from "~auth/types/__generated/gql/graphql";
import { gqlReq } from "~utils/api/gql-req";

export const isEmailTaken = (
	variables: IsEmailTakenMutationVariables,
	_configs?: unknown,
) => {
	return gqlReq<IsEmailTakenMutation, IsEmailTakenMutationVariables>({
		query: /* GraphQL */ `
			mutation IsEmailTaken($email: String!) {
				isEmailTaken(email: $email)
			}
		`,
		variables,
		authMode: "iam",
	});
};
